function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "tools",
  d: "M16.411,2.25A13.741,13.741,0,0,0,8.84,4.493l8.974,8.974a2.945,2.945,0,0,1,.28,4.206,2.945,2.945,0,0,1-4.206-.28L4.635,8.419A13.8,13.8,0,0,0,2.25,16.411,14.218,14.218,0,0,0,16.411,30.572a15.284,15.284,0,0,0,3.646-.42l9.395,9.395a7.039,7.039,0,1,0,9.955-9.955L30.011,20.2a15.284,15.284,0,0,0,.42-3.646,14.021,14.021,0,0,0-14.02-14.3ZM27.628,16.411a10.67,10.67,0,0,1-.42,2.945l-.42,1.543,1.122,1.122L37.3,31.416a4.038,4.038,0,0,1,1.261,2.945A3.814,3.814,0,0,1,37.3,37.3a4.066,4.066,0,0,1-5.889,0L22.02,27.908,20.9,26.787l-1.543.42a10.67,10.67,0,0,1-2.945.42A11.6,11.6,0,0,1,8.417,24.4a10.7,10.7,0,0,1-3.363-7.992,11.679,11.679,0,0,1,.42-3.085L11.644,19.5a5.8,5.8,0,0,0,8.273.28,5.8,5.8,0,0,0-.28-8.273L13.467,5.335a9.043,9.043,0,0,1,2.8-.42,11.6,11.6,0,0,1,7.993,3.224,11.9,11.9,0,0,1,3.365,8.273Z",
  transform: "translate(-2.248 -2.25)",
  fill: "#ac1ede"
});

var SvgTools = function SvgTools(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39.219,
    height: 39.358,
    viewBox: "0 0 39.219 39.358",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTools, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tools.43a8c8ce.svg";
export { ForwardRef as ReactComponent };